// extracted by mini-css-extract-plugin
module.exports = {"sso":"Signup_sso__201Cb","finePrint":"Signup_finePrint__1OwRw","switch":"Signup_switch__BYJXs"};